import React from 'react';
import { useAuth, VideoChatProvider } from '@monument/core';
import { Helmet } from 'react-helmet';
import { useMembership } from '@services/membership/context';
import { usePostAppointmentState } from '@services/post-appointment/PostAppointmentContext';
import { useHistory } from 'react-router-dom';

export const VideoChatWrapper = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { therapist, physician } = useMembership();
  const { refresh: refreshPostAppointmentState, setCurrentAppointmentBookingId } =
    usePostAppointmentState();
  const history = useHistory();

  return (
    <>
      {isAuthenticated && (therapist || physician) && (
        <Helmet>
          <script async src="https://static.opentok.com/v2/js/opentok.min.js"></script>
          <script
            async
            src="https://static.opentok.com/hardware-setup/v1/js/opentok-hardware-setup.min.js"
          ></script>
        </Helmet>
      )}
      <VideoChatProvider
        {...{
          children,
          onUnmountVideo: async () => {
            await refreshPostAppointmentState();
            history.push('/dashboard');
            setCurrentAppointmentBookingId(''); // Reset bookingId
          },
          videoChatPath: '/care/session',
          onConnectError: () => {
            history.push('/dashboard');
          },
        }}
      />
    </>
  );
};
